import React from 'react';
import App from '../App/App';
import {Cards, ImageLayer, ProductBanner} from '../../components';
import FuncCard from './FuncCard';
import FeatureCard from './FeatureCard';
import {banner, feature, func, structure} from './config';

export default function ProductWMS() {
  if (!global.isServer) {
    document.title = '运输管理系统-运输全流程透明化、计费对账自动化';
  }
  return (
    <App className='ProductTMS'>
      <ProductBanner data={banner}/>
      <Cards title='产品特点' data={feature} lg={3} md={2} grey size='middle'>
        <FeatureCard />
      </Cards>
      <Cards title='功能模块' data={func} md={4} lm={2} size='middle'>
        <FuncCard />
      </Cards>
      <ImageLayer title='功能架构' src={structure} grey size='middle'/>
    </App>
  );
};



// WEBPACK FOOTER //
// ./src/routes/ProductTMS/ProductTMS.js